"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var initialDoc = Symbol("initial");
var isDeleted = Symbol("isDeleted");
var IdKey = Symbol("IdKey");
var IdType = Symbol("IdType");
var DocType = Symbol("DocType");
exports.modelSymbols = {
    initialDoc: initialDoc,
    isDeleted: isDeleted,
    IdKey: IdKey,
    IdType: IdType,
    DocType: DocType,
};
